<app-card-table
    translatePrefix="database.organizationAdministrationPage.centresOfOrganization.table."
    [tableTitle]="'database.organizationAdministrationPage.centresOfOrganization.table.title'"
    [columns]="[{name: 'name'}, {name: 'validFrom'}, {name: 'validTo'}, {name: 'phone'}, {name: 'email'}, {name: 'address'}, {name: 'responsiblePerson'}]"
    [items]="centres"
    (createCallback)="createCenter()"
    (deleteCallbackWithEvent)="deleteCenter($event)"
    (detailCallback)="detailCenter($event)"
    [showDelete]="isAllowed['organization.update']()"
>
    <ng-template pTemplate="validFrom" let-item="item">
        {{ (item.basicInfos | currentValid)?.validFrom | shortDate }}
    </ng-template>

    <ng-template pTemplate="validTo" let-item="item">
        {{ (item.basicInfos | currentValid)?.validTo | shortDate }}
    </ng-template>

    <ng-template pTemplate="name" let-item="item">
        {{ (item.basicInfos | currentValid)?.name }}
    </ng-template>

    <ng-template pTemplate="email" let-item="item">
        {{ (item.basicInfos | currentValid)?.email }}
    </ng-template>

    <ng-template pTemplate="address" let-item="item">
        @if (item.addresses | currentValid; as current) {
            {{ current.address.name + ', ' + current.address.location }}
        }
    </ng-template>

    <ng-template pTemplate="phone" let-item="item">
        {{ (item.basicInfos | currentValid)?.phone }}
    </ng-template>
    >

    <ng-template pTemplate="responsiblePerson" let-item="item">
        {{ item.representativePersons | currentValid | formatPerson }}
    </ng-template>
</app-card-table>

<p-dialog
    [header]="'database.organizationAdministrationPage.centresOfOrganization.newCentre' | translate"
    [(visible)]="createCenterModalVisible"
    [modal]="true"
    [maximizable]="false"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closeCreateCenterModal()"
>
    <app-center-basic-infos
        [hideLogo]="true"
        [hideTable]="true"
        (infoCreated)="isAllowed['organization.update'](); closeCreateCenterModal()">
    </app-center-basic-infos>
</p-dialog>
